import { createFileRoute, Link } from '@tanstack/react-router'
import { ArrowLeftIcon } from 'lucide-react'

import { BugEntry } from '@/components/bugs/bug-entry'
import { Frame } from '@/components/frame'
import { PageHeader } from '@/components/page-header'
import { ReturnLink } from '@/components/return-link'
import { Button } from '@/components/ui/button'
import { RETURN_SHAPE } from '@/lib/return-to'
import { matching, readSearch } from '@/lib/search-params'

const ID = /^[0-9a-f]{24}$/

/** Lot 47 : la saisie à la chaîne — un bug, puis le suivant. */
export const Route = createFileRoute('/_app/qa/bugs/nouveau')({
  validateSearch: (search: Record<string, unknown>) =>
    readSearch({ client: matching(ID), projet: matching(ID), ...RETURN_SHAPE }, search),
  component: NewBugPage,
})

function NewBugPage() {
  const { client, projet } = Route.useSearch()
  return (
    <div className="space-y-6">
      <PageHeader
        eyebrow={
          <ReturnLink
            className="-ml-2"
            fallback={
              <Button asChild variant="ghost" size="sm" className="-ml-2">
                <Link to="/qa/bugs">
                  <ArrowLeftIcon />
                  Retour aux bugs
                </Link>
              </Button>
            }
          />
        }
        title="Signaler un bug"
        documentTitle="Signaler un bug"
      />
      <Frame>
        <BugEntry initialClientId={client ?? null} initialProjectId={projet ?? null} />
      </Frame>
    </div>
  )
}
